export const actionMap = {}

export const defaultState = {
    authenticated: undefined,
    username: undefined,
    error: undefined,
    loginUrl: "",
    CSRF: undefined,
    isLoading: false
}

export default (reduxState = defaultState, action) => {
    if (action !== undefined && actionMap[action.type]) {
        return actionMap[action.type](reduxState, action)
    }
    return reduxState
}


// WEBPACK FOOTER //
// ./src/screens/login/reducers/index.js